import { IconSettings } from "app/components/Icon/Icon";
import { FormattedMessage } from "react-intl";
import { connect, useSelector } from "react-redux";
import type { UserType } from "../../../../types/userType";
import VerificationStatus from "../../components/VerificationStatus/VerificationStatus";
import AccountMenuList from "../components/AccountMenuList/AccountMenuList";
import "./AsianSettingsScreen.scss";

const AsianSettingsScreen = (props: { user: UserType }) => {
  const { verifiedStatus } = props.user;

  return (
    <div className="asian-settings-screen">
      <div className="asian-settings-screen__header">
        <div className="asian-settings-screen__header__title">
          <IconSettings />
          <FormattedMessage tagName="span" id="navigation-open-settings" />
        </div>
      </div>
      <div className="asian-settings-screen__content">
        <AccountMenuList
          verifiedStatus={verifiedStatus}
          verifiedStatusFormatedText={
            <VerificationStatus verifiedStatus={verifiedStatus} />
          }
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  user: state.userModel.user,
});

const mapDispatchToProps = (dispatch: any) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AsianSettingsScreen);
